import { Component, input, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { Subject, take } from 'rxjs';
import { GridColConfig } from 'src/app/core/custom-grid/custom-grid';
import { CustomOverlayMessaggeComponent } from 'src/app/core/custom-overlay-messagge/custom-overlay-messagge.component';
import { LocalStorageService } from 'src/app/services/local-storage.service';
import { EnigmaDto } from '../gestione-enigmi/enigmi-dto';
import { GestioneEnigmiService } from '../gestione-enigmi/gestione-enigmi.service';
import { CardSummarySinglelineComponent } from "src/app/core/card-summary-singleline/card-summary-singleline.component";
import { MatIconModule } from "@angular/material/icon";
import { StoryDto } from './storie-dto';
import { MatMenuModule } from "@angular/material/menu";
import { StorieEnigmiService } from './storie-enigmi.service';
import { ToastService } from 'src/app/core/toast/toast.service';
import { MatButtonModule } from '@angular/material/button';

@Component({
  selector: 'app-storie-enigmi',
  templateUrl: './storie-enigmi.component.html',
  styleUrl: './storie-enigmi.component.scss',
  imports: [MatIconModule, MatMenuModule, MatButtonModule]
})
export class StorieEnigmiComponent implements OnInit, OnDestroy {

  @ViewChild(CustomOverlayMessaggeComponent) overlayMessagge: CustomOverlayMessaggeComponent | undefined;
  readonly idEnigma = input.required<string>();
  data = input<StoryDto[]>([]);
  
  options: GridColConfig[] = [];

  private theEnd$ = new Subject<void>();


  constructor(
    private localstorage: LocalStorageService,
    private router: Router,
    private storieEnigmiService: StorieEnigmiService ,
    private toast:ToastService
  ) {
  }



  ngOnInit(): void { //TODO make lazy loading


    this.options = [
      {
        type: 'button',
        name: 'Modifica',
        field: 'none',
        icon: 'pencil',
        cssClass: 'edit-button',
        fieldOptions: {
        },
        width: '40'
      },
      {
        type: 'text',
        name: 'Nome',
        field: 'name',
        fieldOptions: {
        }
      },
      {
        type: 'text',
        name: 'Descrizione',
        field: 'description',
        fieldOptions: {
        }
      },
      {
        type: 'button',
        name: 'Elimina',
        field: 'none',
        icon: 'trash',
        cssClass: 'delete-button',
        fieldOptions: {
        },
        width: '40'
      }
    ];
  }

  ngOnDestroy(): void {
    this.theEnd$.next();
    this.theEnd$.complete();
  }


  btnClick(event: any) {
    if (event.action == 'modifica') {
      this.edit(event.data.id)
    }
    if (event.action == 'elimina') {

      this.overlayMessagge?.showDialog();
      this.overlayMessagge!.deleteItem = event.data.id;
    }

  }

  edit(id: string): void {
    this.router.navigate([`/home/storie/${id}`, { oldId: this.idEnigma() }]);
  }


  add(): void {
    this.router.navigate([`/home/storie/new`, this.idEnigma() ]);
  }

  delete(id:string){
    let elemToDelete = this.data().findIndex(x=> x.id == id);
    this.storieEnigmiService.delete(id).pipe(take(1)).subscribe({
      next:()=>{
        this.toast.success('Storia eliminata');
        this.data().splice(elemToDelete,1);
      }
    })
  }

}
